import { To } from "react-router-dom";

export const routes: { [key: string]: To } = {
  index: "/",
  products: "/products",
  addProduct: "/add-product",
  customers: "/customers",
  customerTransactions: "/customers/:id/transactions",
  addCustomer: "/add-customer",
  suppliers: "/suppliers",
  supplierTransactions: "/supplier/:id/transactions",
  addSupplier: "/add-supplier",
  brands: "/brands",
  addBrand: "/add-brand",
  categories: "/categories",
  addCategory: "/add-category",
  actions: "/actions",
  purchases: "/purchases",
  addPurchase: "/add-purchase",
  addPurchaseReturn: "/add-purchase-return",
  purchaseReport: "/purchase-report",
  purchaseReturnReport: "/purchase-return-report",
  sales: "/sales",
  addSale: "/add-sale",
  addSaleReturn: "/add-sale-return",
  salesReport: "/sales-report",
  salesReturnReport: "/sales-return-report",
  users: "/users",
  addUser: "/add-user",
  backup: "/backup",
  account: "/account",
  settings: "/settings",
  businessSetting: "/business-setting",
  productHistory: "/products/:id/product-history",
  materializedView: "/materialized-view",
  help: "/help",
  addissue: "/add-issue",
  journalReport: "/journal-report",
  chartOfAccounts: "/chart-of-accounts",
  eachChartOfAccount: "/chart-of-accounts/:id",
  chartOfAccountsType: "/chart-of-accounts-type",
  addBank: "/add-bank",
  banks: "/banks",
  balanceSheet: "/balance-sheet",
  profitLossAccount: "/profit-loss-account",
  "404": "*",
};
